import {Component, computed, input} from '@angular/core';
import {HrToolAiCapabilityLevel} from '@frontend/shared-api';
import {
  HR_TOOL_AI_CAPABILITY_LEVEL_RANK,
  HR_TOOL_AI_CAPABILITY_MAX_RANK,
} from '../../constants/hr-tool-ai-capability.constants';

@Component({
  selector: 'app-ai-capability-dots',
  templateUrl: './ai-capability-dots.component.html',
  host: {class: 'inline-flex items-center gap-1', 'aria-hidden': 'true'},
})
export class AiCapabilityDotsComponent {
  readonly level = input<HrToolAiCapabilityLevel | null>(null);

  protected readonly dots = computed(() => {
    const level = this.level();
    const rank = level ? HR_TOOL_AI_CAPABILITY_LEVEL_RANK[level] : 0;
    return Array.from({length: HR_TOOL_AI_CAPABILITY_MAX_RANK}, (_, index) =>
      index < rank ? 'pi pi-circle-fill text-button-red' : 'pi pi-circle-fill text-gray',
    );
  });
}
